'use strict'

{ escape } = require './m_underscore_replacements'

makeTag = (name, attr = {}, content = '') ->
  [attr, content] = [{}, attr]  if typeof attr is 'string'
  html = "<#{ name }"
  tail = "</#{ name }>"
  for key, val of attr
    key = escape key
    val = escape String val
    html += ' ' + key + '="' + val + '"'
  html + '>' + content + tail

makeTag[tagName] = _.partial makeTag, tagName  for tagName in [
  'a'
]

# Groupon.Utils.makeTag
module.exports = makeTag



// WEBPACK FOOTER //
// ./src/frontend/helper/general/m_makeTag.coffee